module.exports = __webpack_public_path__ + "abd68f6a.png";